import { IconFn, IconSvg } from "../createIcon";

export const LockSolidIcon: IconFn = ({ color = "#F56B55", ...props }) => (
  <IconSvg fill="none" viewBox={{ minX: 0, minY: 0, width: 40, height: 48 }} {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M36 22.8H3.6V44.4H36V22.8ZM0 19.2V48H39.6V19.2H0Z" fill={color} />
    <path
      d="M35.3475 15.2738C35.3475 6.85141 28.4961 0 20.0738 0C11.6514 0 4.8 6.85141 4.8 15.2738V19.2H9.16312V15.2738C9.16312 9.25657 14.0594 4.36312 20.0738 4.36312C26.0881 4.36312 30.9844 9.25944 30.9844 15.2738V19.2H35.3475V15.2738Z"
      fill={color}
    />
    <path fillRule="evenodd" clipRule="evenodd" d="M3.6 22.8H36V44.4H3.6V22.8ZM24 30H15.6V37.2H24V30Z" fill={color} />
  </IconSvg>
);
